import { queryOptions } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import {
  getNotifications,
  getUnseenNotificationsCount,
} from 'networking/mindfeed/services/notification.service';

// Other people's actions create notifications, so the feed and the badge go
// stale quickly. Window focus refetches them too, like the Mac app does when
// it comes back to the front.
const NOTIFICATIONS_STALE_MS = 1000 * 30;

// The signed-in user's notification feed, newest first.
export const notificationsQuery = () =>
  queryOptions({
    queryKey: [QueryKey.NOTIFICATIONS],
    queryFn: getNotifications,
    staleTime: NOTIFICATIONS_STALE_MS,
    retry: 1,
  });

// How many notifications the user hasn't seen yet, for the rail badge.
export const unseenNotificationsCountQuery = () =>
  queryOptions({
    queryKey: [QueryKey.NOTIFICATIONS_UNSEEN_COUNT],
    queryFn: getUnseenNotificationsCount,
    staleTime: NOTIFICATIONS_STALE_MS,
    retry: 1,
  });
